module.exports = __webpack_public_path__ + "media/tol/asistenciaporvoz-eb32f050.png";